import UnreadChats from './UnreadChats';
import News from './News';
import PatientInvitationRequests from './PatientInvitationRequests';
import PhysicianWelcomeScreen from './PhysicianWelcomeScreen';
import Support from './Support';
import Tipps from './Tipps';
import DemoBox from './DemoBox';
import VideoBox from './VideoBox';
import Status from './Status';

PhysicianWelcomeScreen.UnreadChats = UnreadChats;
PhysicianWelcomeScreen.PatientInvitationRequests = PatientInvitationRequests;
PhysicianWelcomeScreen.News = News;
PhysicianWelcomeScreen.Tipps = Tipps;
PhysicianWelcomeScreen.Support = Support;
PhysicianWelcomeScreen.DemoBox = DemoBox;
PhysicianWelcomeScreen.VideoBox = VideoBox;
PhysicianWelcomeScreen.Status = Status;

export default PhysicianWelcomeScreen;
